module.exports = __webpack_public_path__ + "static/img/ldtback.2e40cfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ldtback.png
// module id = mXOK
// module chunks = 0